module.exports = __webpack_public_path__ + "public/images/philosophy.64e96fad2d1357edfaf5e05b14f7f19c.png";